import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { findEntityById } from "@qgiv/core-js";
import StoreItemsList from "./StoreItemsList";
import { selectAllProducts } from "../../../redux/slices/productsSlice";

const ConnectedStoreItemsList = ({ controlId, storeCategoryId }) => {
    const products = useSelector(selectAllProducts);
    const productCategories = products;

    const productByCategory = Object.keys(productCategories)
        ? productCategories.find(findEntityById(Number(storeCategoryId)))
        : {};

    const storeItemListProps = {
        controlId,
        productByCategory,
    };
    return <StoreItemsList {...storeItemListProps} />;
};

ConnectedStoreItemsList.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    storeCategoryId: PropTypes.number.isRequired,
};

export default ConnectedStoreItemsList;
